import React from "react";
import { PrivacyTermsWrap } from "components/atoms/Setting/Setting.styles";

const PrivacyTerms = ({data}) => {
 
  return (
    <>
      {data.map((value, index) => (
        <PrivacyTermsWrap key={index}>
          <h2>{value.title}</h2>
          {value.paras.map((val, ind) => (
            <p key={ind}>{val.para}</p>
          ))}
        </PrivacyTermsWrap>
      ))}
    </>
  );
};

export default PrivacyTerms;
